import MenuItem from './../../menu/menuItem/MenuItem.vue'

export default {
  name: 'about-menu',
  components: {
    MenuItem
  }
}
